import { createStore, combineReducers } from "redux";
import { authReducer } from "src/reducers/authReducer";
import { uiReducer } from "src/reducers/uiReducer";

const reducers = combineReducers({
  ui: uiReducer,
  auth: authReducer,
});

const persistedAuth = (() => {
  try {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (!token || !user) return {};
    return { token, user };
  } catch {
    return {};
  }
})();

const store = createStore(
  reducers,
  { auth: persistedAuth },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
